import { useEffect } from 'react';
import { useField } from 'formik';
import { DateTime } from 'luxon';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers';

const DatePickerField = ({ name, label, size = "small", fullWidth = true, ...props }) => {
  const [field, , helpers] = useField(name);

  // console.log(field.value, DateTime.isDateTime(field.value), "DateTime.isDateTime(field.value)", DateTime.fromJSDate(new Date(field.value)));

  // FIX: Ensure value is a Luxon DateTime object or null (never "" or a JS Date)
  const currentValue = field.value 
    ? (DateTime.isDateTime(field.value) ? field.value : DateTime.fromJSDate(new Date(field.value)))
    : DateTime.local({ zone: "America/New_York" });

  useEffect(() => {
    if (field.value === "") {
      helpers.setValue(DateTime.local({ zone: "America/New_York" }));
    }
  }, [field.value]);

  return (
    <LocalizationProvider dateAdapter={AdapterLuxon}>
      <DatePicker
        {...props}
        label={label}
        value={currentValue}
        // FIX: Use setValue to update the Formik state directly
        onChange={(newValue) => helpers.setValue(newValue)}
        slotProps={{ textField: { size, fullWidth } }}
      />
    </LocalizationProvider>
  );
};

export default DatePickerField;